module.exports = __webpack_public_path__ + "static/media/sample_vin_rake_upload.2b74c4bb.csv";